import AcademicReferenceFields from "./Partials/AcademicReferenceFields";

const SaveForm = () => <AcademicReferenceFields />;

export default SaveForm;
